import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ReportCardPdfService = /** @class */ (function () {
    function ReportCardPdfService(http) {
        this.http = http;
    }
    ReportCardPdfService.prototype.getReportCardPdf = function (businessId, year) {
        var baseURL = '';
        if (environment.name === 'prod') {
            baseURL = 'https://www.aopa.org/';
        }
        else {
            baseURL = 'https://webappstage.aopa.org/';
        }
        this.requestUrl = baseURL + ("customerfeedbackreports/" + year + "/" + businessId + "_" + year + "FlightSchoolReport.pdf");
        return this.http.get(this.requestUrl, { responseType: 'blob', observe: 'response' }).pipe(map(function (res) {
            return new Blob([res.body], { type: 'application/pdf' });
        }));
    };
    ReportCardPdfService.ngInjectableDef = i0.defineInjectable({ factory: function ReportCardPdfService_Factory() { return new ReportCardPdfService(i0.inject(i1.HttpClient)); }, token: ReportCardPdfService, providedIn: "root" });
    return ReportCardPdfService;
}());
export { ReportCardPdfService };
